import { PailRemoveIcon } from './PailRemoveIcon';

/**
 * author: Michael Irigoyen
 * id FC5A2451-43C6-40D1-905D-7E473ACA134C
 * name pail-remove
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-remove.svg
 * tags
 */
export const BucketRemoveIcon = PailRemoveIcon;
export default BucketRemoveIcon